/**
 * API fetch helper for app library search.
 */
import type { ApiResponse } from '../types';

const DEV_BASE = 'https://medicare.ddev.site';

function getBaseUrl(): string {
  if (import.meta.env.DEV) {
    return DEV_BASE;
  }
  return '';
}

const API_PATH = '/jsonapi/staticcontent/app-library';

export async function fetchApps(
  queryString: string
): Promise<ApiResponse> {
  const baseUrl = getBaseUrl();
  const url = `${baseUrl}${API_PATH}?${queryString}`;

  const response = await fetch(url, {
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
  });

  if (!response.ok) {
    throw new Error(`HTTP error: ${response.status}`);
  }

  return response.json();
}
